module.exports = __webpack_public_path__ + "static/media/bell-default.8986a8bf.svg";